import http from '@/plugins/api'
import {
  startLoading
} from '@/plugins/loading'
import * as types from './types'

import router from '@/router'

export default {
  /**
   * Authenticate user's credential
   * @param {Object} params - User's email address and password as `{ email: null, password: null}`
   */
  async authUser({
    commit,
    dispatch
  }, credentials) {
    const r = await startLoading(dispatch, 'authUser', () =>
      http.post('auth/gettoken', credentials)
    )
    // Set token to localStorage
    localStorage.token = r.data.token.access_token

    let location = r.data.location

    localStorage.location = JSON.stringify(location)

    // Set location's logo in localStorage
    // if (location.logo !== null) {
    //   localStorage.locationLogo =
    //     'data:' + location.logoContentType + ';base64,' + location.logo
    // }

    // User loggedUser vuex model
    commit(types.SET_USER)
    return r.data
  },
  /**
   * Request new password
   * @param {String} email - User's email address
   */
  async requestPasswordReset({
    dispatch
  }, email) {
    const r = await startLoading(dispatch, 'requestPasswordReset', () =>
      http.post('users/requestpasswordreset', {
        email
      })
    )

    return r.data
  },
  /**
   * Set new password
   * @param {Object} user - User object with email and password
   */
  async setNewPassword({
    dispatch
  }, user) {
    const r = await startLoading(dispatch, 'setNewPassword', () =>
      http.post('users/setNewPassword', user)
    )

    return r.data
  },
  /**
   * This function is used everytime the route changes, to validad the user is authenticated.
   */
  checkAuth({
    commit
  }) {
    try {
      commit(types.SET_USER)
    } catch (e) {
      commit(types.LOGOUT)
    }
  },
  /**
   * Log out user
   */
  logOut({
    commit
  }) {
    commit(types.LOGOUT)
    router.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js